import { Construction } from 'lucide-react';

import { cn } from '@/lib/cn';
import { useFormat } from '@/hooks/useFormat';
import { NAV_LAYOUT_BY_FORMAT } from '@/tokens/breakpoints';

interface PagePlaceholderProps {
  title: string;
  className?: string;
}

/**
 * Échafaudage temporaire : rend une route réelle et navigable tant que l'écran
 * n'est pas implémenté. Se supprime feature par feature en phase 3.
 *
 * Warning: Règle valable pour les vrais écrans à venir : sur les formats étroits, le
 * titre de la page est porté par la barre haute ou l'en-tête de retour, pas par
 * le contenu. Le répéter ici donnait deux `h1` sur une même page (constaté sur
 * /library et /wishlist). Au-dessus, aucun en-tête ne le porte : c'est l'écran
 * qui doit l'afficher.
 */
export function PagePlaceholder({
  title,
  className,
}: Readonly<PagePlaceholderProps>) {
  const titreDejaAffiche = NAV_LAYOUT_BY_FORMAT[useFormat()] === 'tabbar';

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 px-6 py-24 text-center',
        className,
      )}
    >
      <Construction aria-hidden className="size-8 text-fg-subtle" />
      {!titreDejaAffiche && (
        <h1 className="text-xl font-semibold text-fg wide:text-2xl">{title}</h1>
      )}
      <p className="max-w-sm text-sm text-fg-muted">
        Écran à implémenter — les fondations (thème, i18n, navigation, formats)
        sont en place.
      </p>
    </div>
  );
}
